"use client";

import Image from "next/image";
import { Award, Globe, ArrowRight } from "lucide-react";
import Link from "next/link";

function AdditionalSkills({ courseSections, onApplyNow }) {
  const data = courseSections?.AdditionalSkills;
  if (!data) return null;

  return (
    <section className="w-full py-17.5 md:py-25 lg:py-30 bg-linear-to-r from-[#062a3a] via-[#0b3f55] to-[#0a5c7a]">

      <div className=" max-w-(--max-page-width) mx-auto px-(--container-padding) 
        grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-15 items-center">

        <div className="relative w-full h-75 md:h-115 max-h-120 rounded-xs overflow-hidden">
          <Image
            src={data.image?.url}
            alt={data.image?.alternativeText || "image"}
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, 50vw"
          />
        </div>

        <div className="text-white">

          <p className="text-[11px] tracking-[2px] text-[#FFA201] 
            uppercase mb-2 inline-block bg-[#FFA2011A] px-2 py-2">
            {data.tag}
          </p>

          <h2 className="text-[28px] md:text-[40px] font-bold mb-4 leading-tight ">
            {data.title}
          </h2>

          <p className="text-[14px] md:text-[16px] text-gray-200  mb-7">
            {data.description}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mb-7">
            {data.items?.map((item, index) => (
              <div
                key={item.id || index}
                className="bg-white text-black rounded-md px-4 py-4 flex items-left gap-3 shadow-md flex-col "
              >

                <div className="relative w-10 h-10">
                  <Image
                    src={item.icon}
                    alt="icon"
                    fill
                    className="object-contain"
                  />
                </div>
                <p className="text-[16px] text-[#0A2240] font-semibold w-40 overflow-hidden">{item.text}</p>
              </div>
            ))}
          </div>

          {data.button && (

            <button
              onClick={onApplyNow}
              className="max-w-50 relative group cursor-pointer bg-[#FFA201] px-6 py-2 rounded-none
                    text-black text-lg font-semibold flex items-center justify-center gap-2
                    hover:bg-[#e89500] transition"
            >
              {data.button.text}

              <ArrowRight
                size={25}
                className="transition-transform duration-300 rotate-45 group-hover:rotate-0"
              />
            </button>
          )}

        </div>
      </div>
    </section>
  );
}

export default AdditionalSkills;